import script from "./Lead.vue?vue&type=script&setup=true&lang=js"
export * from "./Lead.vue?vue&type=script&setup=true&lang=js"

import "./Lead.vue?vue&type=style&index=0&id=3f8424fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8424fa"]])

export default __exports__